module.exports = __webpack_public_path__ + "static/g3-9856eba30840ecf16383472890f8cae9.jpg";